import React from 'react';
import {
    Box,
    Container,
    makeStyles,
    Theme,
    Typography,
} from '@material-ui/core';
import { EmailMarketingPlan } from './components';
import Page from 'src/components/Page';
import { useTranslation } from 'react-i18next';
import { Card } from 'src/shared/ui';
import { PlansContainer } from '../components';
import { EMAIL_MARKETING_PLANS } from './constants/plans';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        minHeight: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(5),
    },
    heading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

export const EmailMarketingView = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Page title={t('Plans.EmailMarketing')} className={classes.root}>
            <Container maxWidth={false}>
                <Card>
                    <Box className={classes.container}>
                        <Box className={classes.heading}>
                            <Typography
                                variant="h1"
                                color="textPrimary"
                                style={{ fontWeight: 700 }}
                            >
                                {t('Plans.EmailMarketing')}
                            </Typography>
                        </Box>
                        <PlansContainer>
                            {EMAIL_MARKETING_PLANS.map((plan) => (
                                <EmailMarketingPlan
                                    key={plan.name}
                                    plan={plan}
                                />
                            ))}
                        </PlansContainer>
                    </Box>
                </Card>
            </Container>
        </Page>
    );
};
